Hideaways.popups = [];

Hideaways.popup = function () {
    Array.prototype.forEach.call(document.querySelectorAll('.js-popup'), function (element) {
        var popup = new Popup(element);
        popup.init();

        Hideaways.popups.push(popup);
    });

    Array.prototype.forEach.call(document.querySelectorAll('.js-popup-form'),
        function (element) {
            element.addEventListener('submit', function (event) {
                event.preventDefault();
                var form = $(element);
                var url = form.attr('action');
                var message = form.find('.popup-form__message');
                message.hide();

                $.ajax({
                    type: "POST",
                    url: url,
                    data: form.serialize(),
                }).then(function () {
                    window.location = '/brochure-download';
                    element.reset();
                }).fail(function (data) {
                    message.html('Sorry, we could not process your request.<br />Please check the form and try again').show();
                });
            })
        }
    )
    ;
};
